/**
 * Horizontal tab navigation for the dashboard — Overview, Sites, Trends, Data.
 */

import { NavLink, Link } from 'react-router-dom';
import { BarChart3, LineChart, LayoutDashboard, Table2, Home, Activity } from 'lucide-react';

const TABS = [
  { to: '/dashboard', label: 'Overview', icon: LayoutDashboard, end: true },
  { to: '/dashboard/sites', label: 'Site Comparison', icon: BarChart3, end: false },
  { to: '/dashboard/trends', label: 'Trends', icon: LineChart, end: false },
  { to: '/dashboard/profile', label: 'Site Profile', icon: Activity, end: false },
  { to: '/dashboard/observations', label: 'Observations', icon: Table2, end: false },
] as const;

export function DashboardNav() {
  return (
    <nav className="border-b bg-background">
      <div className="mx-auto flex max-w-7xl items-center gap-1 px-6">
        <Link
          to="/"
          className="mr-2 inline-flex items-center gap-2 border-b-2 border-transparent px-3 py-3 text-sm font-medium text-muted-foreground transition-colors hover:border-border hover:text-foreground"
          title="Back to Home"
        >
          <Home className="h-4 w-4" />
          <span className="hidden sm:inline">Home</span>
        </Link>
        <div className="mr-2 h-5 w-px bg-border" />
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              `inline-flex items-center gap-2 border-b-2 px-4 py-3 text-sm font-medium transition-colors ${
                isActive
                  ? 'border-dece-navy text-dece-navy'
                  : 'border-transparent text-muted-foreground hover:border-border hover:text-foreground'
              }`
            }
          >
            <tab.icon className="h-4 w-4" />
            <span className="hidden sm:inline">{tab.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
